import { __values } from "tslib";
import { Breakpoint, BreakpointNames } from './Breakpoint';
export function isBreakpointBelow(referenceBreakpoint, breakpoint) {
    return (BreakpointNames.indexOf(breakpoint) <
        BreakpointNames.indexOf(referenceBreakpoint));
}
export function isBreakpointBelowIncluding(referenceBreakpoint, breakpoint) {
    return (BreakpointNames.indexOf(breakpoint) <=
        BreakpointNames.indexOf(referenceBreakpoint));
}
export function isBreakpointAbove(referenceBreakpoint, breakpoint) {
    return (BreakpointNames.indexOf(breakpoint) >
        BreakpointNames.indexOf(referenceBreakpoint));
}
export function isBreakpointAboveIncluding(referenceBreakpoint, breakpoint) {
    return (BreakpointNames.indexOf(breakpoint) >=
        BreakpointNames.indexOf(referenceBreakpoint));
}
export function isBreakpointBetween(fromBreakpoint, toBreakpoint, breakpoint) {
    return (isBreakpointAbove(fromBreakpoint, breakpoint) &&
        isBreakpointBelow(toBreakpoint, breakpoint));
}
export function isBreakpointBetweenIncluding(fromBreakpoint, toBreakpoint, breakpoint) {
    return (isBreakpointAboveIncluding(fromBreakpoint, breakpoint) &&
        isBreakpointBelowIncluding(toBreakpoint, breakpoint));
}
export function getBreakpointByWidth(width) {
    var e_1, _a;
    var breakpoint = BreakpointNames[0];
    try {
        for (var BreakpointNames_1 = __values(BreakpointNames), BreakpointNames_1_1 = BreakpointNames_1.next(); !BreakpointNames_1_1.done; BreakpointNames_1_1 = BreakpointNames_1.next()) {
            var breakpointName = BreakpointNames_1_1.value;
            if (width >= Breakpoint[breakpointName]) {
                breakpoint = breakpointName;
            }
            else {
                break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (BreakpointNames_1_1 && !BreakpointNames_1_1.done && (_a = BreakpointNames_1.return)) _a.call(BreakpointNames_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return breakpoint;
}
//# sourceMappingURL=BreakpointUtils.js.map